import styled from "@emotion/styled";

export const DrawerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1200px;
  ${({ theme }) => theme.breakpoints.sm.up} {
    padding-top: 24px;
  }
`;

export const DrawerBoard = styled.div`
  position: relative;
  width: 100%;
  max-width: 264px;
  margin: 24px auto;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "all")};
  order: 2;

  padding: 12px 0 8px 0;

  ${({ theme }) => theme.breakpoints.sm.up} {
    max-width: 480px;
    width: 49%;
    order: 1;
    margin: 0 0 0 auto;
    padding: 0 32px 0 32px;
  }
`;

export const DrawerOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(p) =>
    p.isOverlay ? "rgba(255, 255, 255, 0.5)" : "none"};
  transition: background-color 100ms;
  z-index: 999;
  pointer-events: ${(p) => (p.isOverlay ? "all" : "none")};

  :after {
    ${(p) => p.isOverlay && `content: '';`}
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    width: 100px;
    height: 100px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    font-weight: 700;
    background-color: rgba(0, 0, 0, 0.65);
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 69 96'%3e%3cpath fill='%23FFF' fill-rule='nonzero' d='M5.6 82c1 0 1.9.2 2.7.5.8.4 1.4.9 1.8 1.5.4.7.6 1.4.6 2.2H7.5V86c0-.4-.2-.8-.5-1a2 2 0 00-1.4-.5c-.6 0-1 .1-1.4.4-.4.2-.5.6-.5 1 0 .3.2.6.5.9.4.3 1 .6 2 .9 1 .3 1.7.6 2.3 1 1.5.8 2.2 2 2.2 3.5 0 1.2-.4 2-1.3 2.8a6 6 0 01-3.7 1c-1.1 0-2.1-.2-3-.6-.9-.4-1.6-1-2-1.6-.5-.7-.7-1.5-.7-2.4h3.3v.2c0 .6.2 1 .6 1.4.3.3 1 .5 1.8.5.5 0 1-.1 1.3-.3.3-.3.5-.6.5-1 0-.5-.2-.9-.6-1.1-.3-.3-.9-.6-1.7-.9-.9-.3-1.6-.5-2.1-.8-1.8-.9-2.7-2-2.7-3.6 0-.7.2-1.4.7-2 .4-.5 1-1 1.8-1.3.8-.3 1.7-.5 2.7-.5zm19.9.2v2.5h-4v11.1H18v-11h-4v-2.6h11.4zm9.7 0l5 13.6h-3.5l-.8-2.5h-4.5l-.8 2.5h-3.5l5-13.6h3zm13.8 0h.3c1.4 0 2.6.4 3.4 1 1 .8 1.4 1.8 1.4 3.1 0 1-.2 1.7-.6 2.4a4 4 0 01-1.8 1.5l2.9 5.5v.1H51L48.7 91h-1.8v4.8h-3.3V82.2H49zm19.7 0v2.5h-4v11.1h-3.4v-11h-4v-2.6h11.4zm-35 3.8l-1.5 4.7H35L33.6 86zM49 84.7h-2.1v3.8h2c.7 0 1.1-.2 1.5-.5.3-.4.4-.8.4-1.4 0-.6-.1-1-.4-1.4-.4-.3-.8-.5-1.4-.5zM15.6 0a13.6 13.6 0 0111.8 20.4l-2-3.4a10.4 10.4 0 10-11.7 6.9l2 3.4a13.6 13.6 0 010-27.3zm40.9 29l5.1 8.8c2.5 4.4 9.3 19.3-1.6 25.6l-11 6.3c-5.9 3.4-13.4-.8-15.6-1.9-1.6-.8-12.9-13.7-15.3-15.1-.4-.2-4-.9-4.3-1.2-1.4-1.7.2-4.2 2.5-5 1.7-.7 4-.5 7 .7 3.4 1.2 10.3 7.1 10.6 6.7.3-.4-.6-1.9-.6-1.9l-19-33s-2-3.4 1.3-5.4c3.5-2 5.5 1.4 5.5 1.4l13.5 23.4-3-5v-.2c-.3-.6-1.5-3.5 1.5-5.2 3.4-2 5.4 1.4 5.4 1.4l3.6 6.2-2.6-4.5V31c-.4-.7-1.6-3.5 1.4-5.3 3.5-2 5.4 1.5 5.4 1.5l1 1.7v-.1c-.4-.7-1.5-3.6 1.5-5.3 3.4-2 5.4 1.4 5.4 1.4l2.2 4z'/%3e%3c/svg%3e ");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 32px 35px;
  }
`;

export const DrawerExplanation = styled.div`
  width: 100%;
  ${({ theme }) => theme.snippets.paddingLikeText}

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  order: 1;

  ${({ theme }) => theme.breakpoints.sm.up} {
    padding: 0 32px 0 0 !important;
    width: 49%;
    order: 2;
  }
`;

export const InitialText = styled.div`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  margin-bottom: 32px;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.sm.down} {
    align-items: center;
    font-size: 15px;
    order: 1;
    margin-bottom: -12px;
    text-align: center;
  }
`;

export const Left = styled.div`
  flex: 0 0 40px;
  display: flex;
  order: 2;

  > svg {
    margin: 8px 2px 0 -2px;
    width: 35px;
    height: 33.5px;
  }

  ${({ theme }) => theme.breakpoints.sm.down} {
    margin-bottom: 0;
    align-items: center;
    > svg {
      margin: 24px 0 12px;
      width: 38px;
      height: 11px;
      transform: rotate(90deg) scale(-1, -1) translateY(-20px);
    }
  }
`;

export const Right = styled.div`
  flex-grow: 1;
  order: 1;

  ${({ theme }) => theme.breakpoints.sm.up} {
    padding: 0 48px 0 0;
  }
`;

export const RestartButton = styled.button`
  ${({ theme }) => theme.snippets.resetButton}
  font-weight: bold;
  margin-top: 12px;

  /* make whole message clickable */
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

export const DrawerResults = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.sm.up} {
    padding: 0;
    justify-content: flex-start;
  }
`;

export const ElectorsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: 16px;
  position: relative;
  ${({ theme }) => theme.breakpoints.sm.down} {
    margin: 0;
    flex-direction: column;

    > figure {
      margin: 7px -8px 7px 16px !important;
    }
  }
`;

export const ElectorsTitle = styled.h6`
  font-size: 16px;
  height: 16px;
  position: absolute;
  margin: 0;
  top: -17px;
  ${({ theme }) => theme.breakpoints.sm.down} {
    display: none;
  }
`;

export const ShowSolutionWrapper = styled.div`
  text-align: center;
  margin: 24px 16px;
  ${({ theme }) => theme.breakpoints.sm.up} {
    margin: 64px auto 48px;
  }
`;

export const SolutionWrapper = styled.div`
  max-height: ${(p) => (p.isVisible ? 2500 : 0)}px;
  background: ${(p) => p.theme.colors.grey90};
  transition: max-height 500ms ease-in-out;
  overflow: hidden;
`;
